/**
 * Converts megabytes (MB) to bytes.
 * @param value The value in megabytes.
 * @returns The converted value in bytes.
 */
export const mbToBytes = (value: number): number => {
  return value * 1024 * 1024;
};

/**
 * Converts bytes to megabytes (MB).
 * @param value The value in bytes.
 * @returns The converted value in megabytes.
 */
export const bytesToMb = (value: number): number => {
  return value / (1024 * 1024);
};
